// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Albert+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    /* ===== IMPORTACIÓN DE FUENTES ===== */

    /* ===== VARIABLES GLOBALES (PALETA DE COLORES, FUENTES, ETC) ===== */
    :root {
      --naranja: #FF3B00;
      --azul: #02ABE7;
      --azulCielo: #E6EFFA;
      --morado: #9b9af3;
      --textoBlanco: #F0F0F0;
      --textoNegro: #2B2B2B;
      --deshabilitado: #E9E9E9;
      --textoDeshabilitado: #D6D6D6;
      --azulFuerte: #020E38;
      --borderColor: #575757;
      --inputsColor: #231F20;
      --inputsActivo: #E9F4FF;
      --inputsDisabled: #DBDBDB;
      --inputsTxtDisabled: #BEBEBE;
      --borderValid: #005531;
      --inputValid: #C1FFE0;
      --borderInValid: #F70000;
      --inputInValid: #FFE8E7;
      --fontFamilyAlbert: "Albert Sans", sans-serif;
      --negroFooter: #141414;
    }

    /* ===== RESETEO Y ESTILOS BASE ===== */
    * {
      box-sizing: border-box;
      font-family: var(--fontFamilyAlbert);
      color: var(--textoNegro);
      line-height: normal;
      font-weight: 400;
      padding: 0px;
      margin: 0px;
      position: relative;
      transition: 0.5s;
      text-decoration: none;
      font-size: 16px;
    }

    *:hover {
      transition: 0.5s;
    }

    body {
      background-color: #FFFFFF;
    }

    li::marker {
      content: none;
    }

    /* ===== CLASES DE UTILIDAD/AYUDA (Puedes mantenerlas aquí si las usas en muchos componentes) ===== */
    .BGAzulCielo {
      background-color: var(--azulCielo);
    }
    .BGBlanco {
      background-color: var(--textoBlanco);
    }
    .BGAzul {
      background-color: var(--azul);
      color: black;
    }
    .BGNaranja {
      background-color: var(--naranja);
      color: white;
    }
    .BGAzulMarca {
      background-color: var(--azul);
      color: var(--textoBlanco);
    }
    .BGNegro {
      background-color: black;
      color: var(--textoBlanco);
    }
    .CBlanco {
      color: var(--textoBlanco);
    }
    .CNegro {
      color: var(--textoNegro);
    }
    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
    }

    `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"IAAI,uCAAuC;;IAGvC,qEAAqE;IACrE;MACE,kBAAkB;MAClB,eAAe;MACf,oBAAoB;MACpB,iBAAiB;MACjB,sBAAsB;MACtB,qBAAqB;MACrB,wBAAwB;MACxB,6BAA6B;MAC7B,qBAAqB;MACrB,sBAAsB;MACtB,sBAAsB;MACtB,uBAAuB;MACvB,yBAAyB;MACzB,4BAA4B;MAC5B,sBAAsB;MACtB,qBAAqB;MACrB,wBAAwB;MACxB,uBAAuB;MACvB,6CAA6C;MAC7C,sBAAsB;IACxB;;IAEA,uCAAuC;IACvC;MACE,sBAAsB;MACtB,oCAAoC;MACpC,wBAAwB;MACxB,mBAAmB;MACnB,gBAAgB;MAChB,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,gBAAgB;MAChB,qBAAqB;MACrB,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,aAAa;IACf;;IAEA,qGAAqG;IACrG;MACE,kCAAkC;IACpC;IACA;MACE,oCAAoC;IACtC;IACA;MACE,6BAA6B;MAC7B,YAAY;IACd;IACA;MACE,gCAAgC;MAChC,YAAY;IACd;IACA;MACE,6BAA6B;MAC7B,yBAAyB;IAC3B;IACA;MACE,uBAAuB;MACvB,yBAAyB;IAC3B;IACA;MACE,yBAAyB;IAC3B;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,UAAU;MACV,YAAY;MACZ,gBAAgB;MAChB,sBAAsB;MACtB,mBAAmB;MACnB,eAAe;IACjB","sourcesContent":["    /* ===== IMPORTACIÓN DE FUENTES ===== */\n    @import url('https://fonts.googleapis.com/css2?family=Albert+Sans:ital,wght@0,100..900;1,100..900&display=swap');\n\n    /* ===== VARIABLES GLOBALES (PALETA DE COLORES, FUENTES, ETC) ===== */\n    :root {\n      --naranja: #FF3B00;\n      --azul: #02ABE7;\n      --azulCielo: #E6EFFA;\n      --morado: #9b9af3;\n      --textoBlanco: #F0F0F0;\n      --textoNegro: #2B2B2B;\n      --deshabilitado: #E9E9E9;\n      --textoDeshabilitado: #D6D6D6;\n      --azulFuerte: #020E38;\n      --borderColor: #575757;\n      --inputsColor: #231F20;\n      --inputsActivo: #E9F4FF;\n      --inputsDisabled: #DBDBDB;\n      --inputsTxtDisabled: #BEBEBE;\n      --borderValid: #005531;\n      --inputValid: #C1FFE0;\n      --borderInValid: #F70000;\n      --inputInValid: #FFE8E7;\n      --fontFamilyAlbert: \"Albert Sans\", sans-serif;\n      --negroFooter: #141414;\n    }\n\n    /* ===== RESETEO Y ESTILOS BASE ===== */\n    * {\n      box-sizing: border-box;\n      font-family: var(--fontFamilyAlbert);\n      color: var(--textoNegro);\n      line-height: normal;\n      font-weight: 400;\n      padding: 0px;\n      margin: 0px;\n      position: relative;\n      transition: 0.5s;\n      text-decoration: none;\n      font-size: 16px;\n    }\n\n    *:hover {\n      transition: 0.5s;\n    }\n\n    body {\n      background-color: #FFFFFF;\n    }\n\n    li::marker {\n      content: none;\n    }\n\n    /* ===== CLASES DE UTILIDAD/AYUDA (Puedes mantenerlas aquí si las usas en muchos componentes) ===== */\n    .BGAzulCielo {\n      background-color: var(--azulCielo);\n    }\n    .BGBlanco {\n      background-color: var(--textoBlanco);\n    }\n    .BGAzul {\n      background-color: var(--azul);\n      color: black;\n    }\n    .BGNaranja {\n      background-color: var(--naranja);\n      color: white;\n    }\n    .BGAzulMarca {\n      background-color: var(--azul);\n      color: var(--textoBlanco);\n    }\n    .BGNegro {\n      background-color: black;\n      color: var(--textoBlanco);\n    }\n    .CBlanco {\n      color: var(--textoBlanco);\n    }\n    .CNegro {\n      color: var(--textoNegro);\n    }\n    .sr-only {\n      position: absolute;\n      width: 1px;\n      height: 1px;\n      padding: 0;\n      margin: -1px;\n      overflow: hidden;\n      clip: rect(0, 0, 0, 0);\n      white-space: nowrap;\n      border-width: 0;\n    }\n\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
